import { DialogHeader } from '../../../shared/dialog';
import { Grid, Typography } from '@mui/material';
import { MembersCountBox } from '../../../shared/members-count-box';
import { IAudienceMembersDialogHeader } from './types';
import ArrowBack from 'assets/icons/buttons/arrow-back.svg';
import { styles } from './styles';
import { capitalize } from 'lodash';

export const AudienceMembersDialogHeader = ({
  audienceName,
  isEveryone,
  membersCount,
  onCancel,
}: IAudienceMembersDialogHeader) => {
  return (
    <DialogHeader>
      <ArrowBack style={styles.arrowBack} onClick={onCancel} />
      <Grid sx={styles.membersBox}>
        <Typography sx={styles.audienceName}>{capitalize(audienceName)}</Typography>
        <MembersCountBox count={membersCount} />
      </Grid>
      {isEveryone && <Typography sx={styles.membersText}>All members on the project</Typography>}
    </DialogHeader>
  );
};
